<template>
  <div id="grid-dia-regular">
    <v-container grid-list-xl fluid>
      <v-layout>
        <v-flex lg12>
          <div v-if="loading">
            <loading></loading>
          </div>

          <v-spacer></v-spacer>
          <v-toolbar v-if="verFormControl == true" card color="white">
            <v-toolbar-title class="indigo--text"
              >Resumen Cuadratura Formularios de Control</v-toolbar-title
            >
          </v-toolbar>

          <template v-if="verFormControl == true">
            <v-data-table
              :headers="headers3"
              :items="itemsFormControl"
              :rows-per-page-items="rowsPerPageItems"
              class="elevation-1"
            >
              <template v-slot:items="props">
                <td class="text-xs-left">{{ props.item.descNivel }}</td>
                <td class="text-xs-left">{{ props.item.tipoPrueba }}</td>
                <td class="text-xs-left">{{ props.item.porLC }}%</td>
                <td class="text-xs-left">{{ props.item.porFA }}%</td>
              </template>
            </v-data-table>
          </template>

          <v-card-actions class="pb-3">
            <v-spacer></v-spacer>
            <v-btn
              v-if="botonDescargaFC == true"
              color="primary"
              @click="downloadFC()"
              >Descarga FC</v-btn
            >
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-flex>
      </v-layout>

      <v-layout>
        <v-flex lg12>
          <div v-if="loading">
            <loading></loading>
          </div>

          <v-spacer></v-spacer>

          <v-toolbar v-if="verCuestionarios == true" card color="white">
            <v-toolbar-title class="indigo--text"
              >Resumen Cuadraturas Cuestionarios</v-toolbar-title
            >
          </v-toolbar>

          <template v-if="verCuestionarios == true">
            <v-data-table
              :headers="headers"
              :items="itemsCuestionarios"
              :rows-per-page-items="rowsPerPageItems"
              class="elevation-1"
            >
              <template v-slot:items="props">
                <td class="text-xs-left">{{ props.item.descNivel }}</td>
                <td class="text-xs-left">{{ props.item.tipoPrueba }}</td>
                <td class="text-xs-left">{{ props.item.porCD }}%</td>
                <td class="text-xs-left">{{ props.item.porDL }}%</td>
                <td class="text-xs-left">{{ props.item.porDM }}%</td>
                <td class="text-xs-left">{{ props.item.porCP }}%</td>
              </template>
            </v-data-table>
          </template>

          <v-card-actions class="pb-3">
            <v-spacer></v-spacer>
            <v-btn
              v-if="botonDescargaCues == true"
              color="primary"
              @click="downloadC()"
              >Descarga C</v-btn
            >
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-flex>
      </v-layout>

      <v-layout>
        <v-flex lg12>
          <div v-if="loading">
            <loading></loading>
          </div>

          <v-spacer></v-spacer>

          <v-toolbar v-if="verInsEvaluacion == true" card color="white">
            <v-toolbar-title class="indigo--text"
              >Resumen Cuadraturas instrumentos de evaluacion</v-toolbar-title
            >
          </v-toolbar>

          <template v-if="verInsEvaluacion == true">
            <v-data-table
              :headers="headers2"
              :items="itemsInstEvaluacion"
              :rows-per-page-items="rowsPerPageItems"
              class="elevation-1"
            >
              <template v-slot:items="props">
                <td class="text-xs-left">{{ props.item.descNivel }}</td>
                <td class="text-xs-left">{{ props.item.tipoPrueba }}</td>
                <td class="text-xs-left">{{ props.item.porPCMat }}%</td>
                <td class="text-xs-left">{{ props.item.porPCLen }}%</td>
                <td class="text-xs-left">{{ props.item.porPAMat }}%</td>
                <td class="text-xs-left">{{ props.item.porPALen }}%</td>
                <td class="text-xs-left">{{ props.item.porCE }}%</td>
              </template>
            </v-data-table>
          </template>

          <v-card-actions class="pb-3">
            <v-spacer></v-spacer>
            <v-btn
              v-if="botonDescargaIEva == true"
              color="primary"
              @click="downloadIE()"
              >Descarga IE</v-btn
            >
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>
<script>
import axios from "axios";
import Loading from "@/views/ui/Loading.vue";

export default {
  name: "dia-regular",

  components: {
    Loading,
  },
  props: {},

  data() {
    return {
      titleGrafica: "",
      loading: false,
      id: "",
      totalRegistro: "",
      rowsPerPageItems: [20],
      pagination: {
        page: 1,
        rowsPerPage: 50,
        pages: 0,
      },
      totalPages: 0,
      totalRegistros: "",
      idContrato: "",
      headers: [
        { text: "Nivel", align: "left", sortable: false, value: "rut" },
        { text: "Tipo Prueba", sortable: false, value: "candidato" },
        { text: "% CD", sortable: false, value: "evaluacion" },
        { text: "% DL", sortable: false, value: "fecha" },
        { text: "% DM", sortable: false, value: "" },
        { text: "% CP", sortable: false, value: "" },
      ],
      headers2: [
        { text: "Nivel", align: "left", sortable: false, value: "rut" },
        { text: "Tipo Prueba", sortable: false, value: "candidato" },
        { text: "% PC MAT", sortable: false, value: "evaluacion" },
        { text: "% PC LEN", sortable: false, value: "" },
        { text: "% PA MAT", sortable: false, value: "" },
        { text: "% PA LEN", sortable: false, value: "" },
        { text: "% CE", sortable: false, value: "" },
      ],
      headers3: [
        { text: "Nivel", align: "left", sortable: false, value: "Nivel" },
        {
          text: "Tipo Prueba",
          align: "left",
          sortable: false,
          value: "Tipo Prueba",
        },
        { text: "% LC", align: "left", sortable: false, value: "% LC" },
        { text: "% FA", align: "left", sortable: false, value: "% FA" },
      ],

      // 20-01-2023
      itemsFormControl: [],
      itemsCuestionarios: [],
      itemsInstEvaluacion: [],
      verFormControl: false,
      verCuestionarios: false,
      verInsEvaluacion: false,
      botonDescargaFC: false,
      botonDescargaCues: false,
      botonDescargaIEva: false,
    };
  },
  watch: {
    dialogLoading(val) {
      if (!val) return;
      setTimeout(() => (this.dialogLoading = false), 5000);
    },
  },

  created() {
    this.idContrato = this.$store.getters.contratoStored;
    this.loadData();
  },
  mounted() {},
  computed: {},
  methods: {
    async loadData() {
      this.loading = true;

      this.itemsFormControl = await this.loadFormControl();

      if (this.itemsFormControl.length > 0) {
        this.verFormControl = true;
        this.alerta = false;
        this.botonDescargaFC = true;
      } else {
        this.alerta = true;
      }

      this.itemsCuestionarios = await this.loadCuestionario();

      if (this.itemsCuestionarios.length > 0) {
        this.verCuestionarios = true;
        this.alerta = false;
        this.botonDescargaCues = true;
      } else {
        this.alerta = true;
      }

      this.itemsInstEvaluacion = await this.loadInsEvaluacion();

      if (this.itemsInstEvaluacion.length > 0) {
        this.verInsEvaluacion = true;
        this.alerta = false;
        this.botonDescargaIEva = true;
      } else {
        this.alerta = true;
      }

      this.loading = false;
    },

    async loadFormControl() {
      return await axios
        .get("/cuadraturas/cuadraFormControl/" + this.idContrato)
        .then(function (response) {
          return response.data;
        })
        .catch((error) => {
          if (error) {
            console.log(error.response.data);
          }
          return [];
        });
    },

    async loadCuestionario() {
      return await axios
        .get("/cuadraturas/cuadraCuestionario/" + this.idContrato)
        .then(function (response) {
          return response.data;
        })
        .catch((error) => {
          if (error) {
            console.log(error.response.data);
          }
          return [];
        });
    },

    async loadInsEvaluacion() {
      return await axios
        .get("/cuadraturas/cuadraInstruEvaluacion/" + this.idContrato)
        .then(function (response) {
          return response.data;
        })
        .catch((error) => {
          if (error) {
            console.log(error.response.data);
          }
          return [];
        });
    },

    reload() {
      setTimeout(() => {
        this.$parent.$parent.reloadDocumento();
      }, 1000);
    },

    downloadFC() {
      this.loading = true;
      let fileDownload = "Resumen_Formulario_Control.xlsx";
      let resumen = "1";

      axios({
        url:
          "/cuadraturas/writeExcelCuadraturaDetalle/" +
          fileDownload +
          "/" +
          resumen +
          "/" +
          this.idContrato,
        method: "GET",
        responseType: "blob",
      })
        .then(function (response) {
          const urle = window.URL.createObjectURL(response.data);
          const link = document.createElement("a");
          link.href = urle;
          link.setAttribute("download", fileDownload);
          document.body.appendChild(link);
          link.click();
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
          return [];
        });
      this.loading = false;
    },

    downloadC() {
      this.loading = true;
      let fileDownload = "Resumen_Cuestionario.xlsx";
      let resumen = "2";

      axios({
        url:
          "/cuadraturas/writeExcelCuadraturaDetalle/" +
          fileDownload +
          "/" +
          resumen +
          "/" +
          this.idContrato,
        method: "GET",
        responseType: "blob",
      })
        .then(function (response) {
          const urle = window.URL.createObjectURL(response.data);
          const link = document.createElement("a");
          link.href = urle;
          link.setAttribute("download", fileDownload);
          document.body.appendChild(link);
          link.click();
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
          return [];
        });
      this.loading = false;
    },

    downloadIE() {
      this.loading = true;
      let fileDownload = "Resumen_Instumento_Evaluacion.xlsx";
      let resumen = "3";

      axios({
        url:
          "/cuadraturas/writeExcelCuadraturaDetalle/" +
          fileDownload +
          "/" +
          resumen +
          "/" +
          this.idContrato,
        method: "GET",
        responseType: "blob",
      })
        .then(function (response) {
          const urle = window.URL.createObjectURL(response.data);
          const link = document.createElement("a");
          link.href = urle;
          link.setAttribute("download", fileDownload);
          document.body.appendChild(link);
          link.click();
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
          return [];
        });
      this.loading = false;
    },
  },
};
</script>
